import { Captions, SmallSectionHeader } from 'components/Typography';
import styled from 'styled-components';
import { Divider } from '@material-ui/core';

export const SizedSmallSectionHeader = styled(SmallSectionHeader)`
  && {
    letter-spacing: 0;
    line-height: 23px;
  }
`;

export const SizedCaptions = styled(Captions)`
  &&& {
    font-size: 13px !important;
    line-height: 20px;
    margin-bottom: 0px;
  }
`;

export const ColoredDivider = styled(Divider)`
  && {
    background-color: #979797;
    opacity: 24%;
    margin-top: 50px;
  }
`;
